import classNames from 'classnames';
import { ShopItemType } from 'react-easyrocket';
import { useLocation } from 'react-router';
import coin from 'src/assets/images/event/shop/shopCoin.webp';
import { useLocalCurrency } from 'src/hooks/useLocalCurrency';

export const BuyMoney = ({ item }: { item?: ShopItemType }) => {
  const { currencyIcon, currencyName } = useLocalCurrency();
  const { pathname } = useLocation();

  const isAccount = pathname.includes('account');
  const amountOfMoney = item?.amount ? item?.amount?.[currencyName] / 100 : 0;

  return (
    <div
      className={classNames(
        'flex items-center justify-between gap-5 flex-col-reverse text-sp_card_text font-bold',
        isAccount ? 'pb-10 pt-0 px-2' : 'pb-10 pt-2.5'
      )}>
      <div
        className={classNames(
          'flex items-center gap-2 text-sp_card_amount font-bold',
          isAccount ? 'text-[40px] pt-3' : 'text-[55px] leading-[55px]'
        )}
        style={{
          textShadow: !isAccount ? '2px 2px 0px var(--sp_card_shadow)' : ''
        }}>
        <span>{amountOfMoney}</span>
        <span>{currencyIcon}</span>
      </div>
      <div className="rounded-[40px] px-[15px] my-[5px] gap-2.5 py-[5px] flex items-center justify-center text-3xl bg-sp_card_coins_bg">
        <span>{item?.costPoints || 0}</span>
        <img src={coin} alt="coin" className="w-[42px]" />
      </div>
    </div>
  );
};
